import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { CommonService } from "src/app/core/services/common.service";
import { DealService } from "src/app/core/services/deal.service";
import { AdspDealService } from "src/app/core/services/adsp-deal.service";
import { PG_DEAL_TYPES } from "src/app/models/common";
import { ioDealTypeMapping } from "src/app/models/insertion-order";
import { AdspViewDealComponent } from "src/app/resources/adsp/adsp-line-item/adsp-view-deal/adsp-view-deal.component";
import { getDateMonthYear } from "../../utils/dateUtil";
import { BdspDealService } from "src/app/core/services/bdsp/bdsp-deal.service";
import { nativeTypes } from "src/app/models/bdsp/bdsp-line-item";
import { BdspStaticService } from "src/app/core/services/bdsp/bdsp-static.service";
import { TdspDealService } from "src/app/core/services/tdsp/tdsp-deal.service";

@Component({
  selector: "app-campaign-deals-targeting",
  templateUrl: "./campaign-deals-targeting.component.html",
  styleUrls: ["./campaign-deals-targeting.component.scss"],
})
export class CampaignDealsTargetingComponent implements OnInit {
  @Input() stepInput: any;

  getAllfunc: Function;
  globalParams: Object = {};
  defaultParams: Object = {};
  searchParams: Object = {};
  allDeals: Array<any> = [];
  selectedDeals: Array<any> = [];
  dealsSearchTerm: string;

  dealsDataSource: MatTableDataSource<any>;
  @ViewChild("dealsPaginator") dealsPaginator: MatPaginator;
  @ViewChild("dealsSort") sortdeals: MatSort;
  totalDeals: number;
  dealsCount: number;

  selectedDealsDataSource: MatTableDataSource<any>;
  @ViewChild("dealsPaginatorSelected") selectedDealsPaginator: MatPaginator;
  @ViewChild("dealsSortSelected") sortSelectedDeals: MatSort;

  showSearchInputDeals: boolean = false;
  showSearchInputDealsSelected: boolean = false;

  displayedColumnsDeals: string[] = [];
  selectedDealColumns: string[] = [];

  ioType: string;
  ioDealType: string;
  pgDealTypeOptions = PG_DEAL_TYPES;
  ioDealTypeMapping = ioDealTypeMapping;
  tdspIo;

  inactiveDealIDS: Array<any> = [];
  dealSellers: Array<any> = [];
  selectedSeller: string = "all";
  searchSellerParams = {};

  priceType = {
    "FLOOR RATE": "FR",
    FIXED_CPM: "FC",
    FLAT_FEE: "FF",
  };

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private dealService: DealService,
    private adspDealService: AdspDealService,
    private bdspDealService: BdspDealService,
    private bdspStaticService: BdspStaticService,
    private tdspDealService: TdspDealService
  ) {}

  ngOnInit(): void {
    this.ioType = this.stepInput.ioType;
    this.ioDealType = this.stepInput.ioDealType;
    this.selectedDeals = this.stepInput.selectedDeals;
    this.globalParams = this.stepInput.globalParams;
    this.tdspIo = this.stepInput.tdspInsertionOrder;
    this.setRequiredData();
    if (this.stepInput.dsp == "bdsp") {
      this.getSeller();
    }
  }

  getSeller(params = {}) {
    params = { ...params, ...this.searchSellerParams };
    this.bdspStaticService
      .getStaticData("inventory-sources", 0, 300, params)
      .subscribe((res) => {
        this.dealSellers = res.inventory_sources;
      });
  }

  sellerSelectionChange() {
    if (this.selectedSeller != "all") {
      this.defaultParams["seller_key"] = this.selectedSeller;
    } else {
      delete this.defaultParams["seller_key"];
    }
    this.getCommonData().then(() => {});
  }

  searchSellers(event) {
    let filter = event.toLowerCase();
    this.searchSellerParams["fields"] = "name";
    this.searchSellerParams["name"] = filter;
    this.getSeller();
  }

  getCommonData(params = {}, merge: boolean = false): Promise<void> {
    params = {
      ...params,
      ...this.globalParams,
      ...this.defaultParams,
      ...this.searchParams,
    };
    return new Promise((resolve, reject) => {
      this.getAllfunc(params).subscribe(
        (res) => {
          if (merge) {
            this.allDeals = this.allDeals.concat(
              res.data.map((e) => ({
                ...e,
                selected: false,
              }))
            );
            this.updateAllDealsTable();
            this.updateSelectedDealsTable();
          } else {
            this.allDeals = res.data.map((e) => ({
              ...e,
              selected: false,
            }));
            this.dealsCount = this.totalDeals = res.count;
            this.updateAllDealsTable();
            this.updateSelectedDealsTable();
          }

          if (this.selectedDeals.length > 0) {
            this.selectedDeals.forEach((deal) => {
              this.allDeals = this.allDeals.filter((ele) => ele.id != deal.id);
            });
            this.dealsCount = this.searchParams["search_term"]
              ? this.allDeals.length
              : this.totalDeals - this.selectedDeals.length;
            this.updateAllDealsTable();
            this.updateSelectedDealsTable();
          }
          resolve();
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  setRequiredData(params = {}) {
    // Apnx Deals
  if (this.stepInput.dsp == "vdsp") {
      this.getAllfunc = (params) => this.dealService.list(params);

      this.displayedColumnsDeals = this.selectedDealColumns = [
        "checkbox",
        "deal_name",
        "id",
        "status",
        "price",
      ];

      //Set required query params

      if (this.ioType == "private_deal")
        this.defaultParams["is_private"] = "private";
      else this.defaultParams["is_private"] = "regular";
      this.defaultParams["deal_type"] = this.ioDealType;

      this.getCommonData().then(() => {});
    }
    // Amazon Deals
    else if (this.stepInput.dsp == "adsp") {
      this.getAllfunc = (params) => this.adspDealService.list(params);

      this.displayedColumnsDeals = this.selectedDealColumns = [
        "checkbox",
        "name",
        "start_date",
        "price",
      ];

      //Set required query params

      this.defaultParams["deal_status"] = "active";
      if (this.ioDealType == "prime") {
        this.defaultParams["deal_type"] = "preferred,private_auction";
        this.defaultParams["deal_source"] = "Prime Video ads";
      } else {
        this.defaultParams["deal_type"] = this.ioDealType;
      }
      this.defaultParams["line_item_type"] =
        this.stepInput.lineItem.line_item_type;
      this.defaultParams["max_cpm"] = this.stepInput.maxCPM;
      this.defaultParams["start_date"] = getDateMonthYear(
        this.stepInput.lineItem.start_date
      );
      this.defaultParams["end_date"] = getDateMonthYear(
        this.stepInput.lineItem.end_date
      );

      this.getCommonData().then(() => {});
    }

    // Sensitive Categories Deals
    else if (this.stepInput.dsp == "bdsp") {
      this.getAllfunc = (params) => this.bdspDealService.list(params);

      this.displayedColumnsDeals = [
        "checkbox",
        "name",
        "id",
        "status",
        "seller.name",
        "price",
      ];

      this.selectedDealColumns = [
        "checkbox",
        "name",
        "id",
        "status",
        "seller.name",
        "price",
        "remove",
      ];

      if (this.ioType == "private_deal")
        this.defaultParams["is_private"] = "private";
      else this.defaultParams["is_private"] = "regular";
      this.defaultParams["deal_format"] = nativeTypes.has(
        this.stepInput.lineItem.type
      )
        ? "native,all"
        : this.stepInput.lineItem.type == "html5"
        ? "banner,all"
        : this.stepInput.lineItem.type == "connected_tv"
        ? "video,all"
        : this.stepInput.lineItem.type + ",all";
      this.defaultParams["deal_type"] = this.ioDealType;
      this.getCommonData().then(() => {});
    }

    else if(this.stepInput.dsp == "tdsp"){
      this.getAllfunc = (params) => this.tdspDealService.list(params);

      this.displayedColumnsDeals = [
        "checkbox",
        "name",
        "id",
        "tdsp_id",
        // "status",
        // "seller.name",
        "price",
      ];

      this.selectedDealColumns = [
        "checkbox",
        "name",
        "id",
        "tdsp_id",
        // "status",
        // "seller.name",
        "price",
        "remove",
      ];
      this.defaultParams["is_private"] = this.tdspIo.io_type == 'private_deal' ? 'private' : 'regular';
      this.defaultParams["deal_type"] = this.tdspIo.io_deal_type;
      this.defaultParams["max_cpm"] = this.stepInput['maxCpm'];
      this.defaultParams["admin_state"] = 'approved';
      this.defaultParams["start_date"] = this.tdspIo.min_flight_start_date.split('T')[0];
      this.defaultParams["end_date"] = this.tdspIo.max_flight_end_date.split('T')[0];
      this.getCommonData().then(() => {});
    }
  }

  updateSelectedDealsTable() {
    this.selectedDealsDataSource = new MatTableDataSource(this.selectedDeals);
    this.selectedDealsDataSource.paginator = this.selectedDealsPaginator;
    this.selectedDealsDataSource.sort = this.sortSelectedDeals;
  }

  updateAllDealsTable() {
    this.dealsDataSource = new MatTableDataSource(this.allDeals);
    this.dealsDataSource.paginator = this.dealsPaginator;
    this.dealsDataSource.sort = this.sortdeals;
    this.dealsDataSource._updatePaginator(this.dealsCount);
  }

  searchDeals() {
    this.searchParams["search_term"] = this.dealsSearchTerm;
    if (this.dealsSearchTerm.length > 3) {
      this.getCommonData();
    } else if (this.dealsSearchTerm.length == 0) {
      this.getCommonData();
    }
  }

  addDeals(row) {
    if (this.stepInput.dsp == "bdsp") {
      row = { ...row, deal_action: "include" };
    }
    this.selectedDeals.push(row);
    this.allDeals = this.allDeals.filter((deal) => deal.id != row.id);
    this.updateSelectedDealsTable();
    this.dealsCount -= 1;
    this.updateAllDealsTable();
    this.proceed();
  }

  removeDeals(row) {
    this.selectedDeals = this.selectedDeals.filter((deal) => deal.id != row.id);
    if (this.stepInput.dsp == "adsp" || this.stepInput.dsp == "bdsp" || this.stepInput.dsp == "tdsp") {
      this.allDeals.unshift(row);
      this.dealsCount += 1;
    }
    if (row.state != "inactive" && this.stepInput.dsp == "vdsp") {
      this.allDeals.unshift(row);
      this.dealsCount += 1;
    }
    this.updateSelectedDealsTable();
    this.updateAllDealsTable();
    this.proceed();
  }

  handlePageEvent(event: PageEvent) {
    let requested_page = event.pageSize * (event.pageIndex + 1);
    let num_elements = 100;
    if (
      requested_page > this.allDeals.length &&
      this.totalDeals > num_elements
    ) {
      let params = {};
      params = {
        start_element:
          event.pageSize >= this.allDeals.length
            ? event.pageSize
            : this.allDeals.length + this.selectedDeals.length,
        num_elements: 100,
      };
      this.getCommonData(params, true);
    }
  }

  showViewDeatails(data) {
    let dialogRef = this.dialog.open(AdspViewDealComponent, {
      width: "60em",
      height: "57em",
      disableClose: true,
      autoFocus: false,
      data: { deal: data, globalParams: this.globalParams },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  proceed() {
    if (this.stepInput.dsp == "vdsp") {
      let inactiveDealCount = this.selectedDeals.filter(
        (deal) => deal.state == "inactive" || deal.state == "expired"
      );
      if (inactiveDealCount.length != 0) {
        this.inactiveDealIDS = inactiveDealCount.map((deal) => deal.id);
      }
    }

    this.commonService.setDealData({
      deal: this.selectedDeals,
    });
  }
}
